import { Doc } from "@scoach/ui/icons";

import { NotesPanel } from "../../../meeting/live/components/NotesPanel.tsx";
import { ScreenSharePreview } from "../../../meeting/live/components/ScreenSharePreview.tsx";
import { InterviewLiveSummaryPanel } from "./InterviewLiveSummaryPanel.tsx";

export interface InterviewContextRailProps {
  meetingId: string;
  stream: MediaStream | null;
  rmsDb: number;
  error: string | null;
  onPickSource: () => void;
  onStopShare: () => void;
  micCapturing?: boolean;
  micError?: string | null;
  /** Open the CV overlay (only shown when a résumé exists). */
  onViewResume?: () => void;
  hasCv?: boolean;
}

/**
 * Left rail for the interview live screen: screen-share preview (reused), a
 * "View résumé" button, interviewer notes, and the live running summary under
 * the notes. (Score, tips and the question checklist live in the right panel.)
 */
export function InterviewContextRail({
  meetingId,
  stream,
  rmsDb,
  error,
  onPickSource,
  onStopShare,
  micCapturing,
  micError,
  onViewResume,
  hasCv,
}: InterviewContextRailProps) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 12,
        height: "100%",
        overflowY: "auto",
      }}
    >
      <ScreenSharePreview
        stream={stream}
        rmsDb={rmsDb}
        error={error}
        onPickSource={onPickSource}
        onStopShare={onStopShare}
        micCapturing={micCapturing}
        micError={micError}
        meetingId={meetingId}
      />
      {hasCv && onViewResume && (
        <button
          type="button"
          className="pill-btn"
          onClick={onViewResume}
          style={{ alignSelf: "flex-start" }}
        >
          <Doc size={14} /> View résumé
        </button>
      )}
      <NotesPanel meetingId={meetingId} />
      <InterviewLiveSummaryPanel meetingId={meetingId} />
    </div>
  );
}
